<div class="px-6 w-full space-y-5 mt-3">
  <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm p-5">
    <div class="space-y-3">
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200 mb-1 block">Fechas</label>
        <app-datepicker (updateDates)="setDatesOnFilter($event)" [selectedFilterRange]="1"></app-datepicker>
      </div>
      <div class="flex justify-end">
        <button pButton [label]="loading ? 'Buscando...' : 'Buscar'" [icon]="loading ? 'pi pi-spin pi-spinner' : 'pi pi-search'"
          class="p-button-sm w-full sm:w-auto" [disabled]="loading" (click)="getPayments()"></button>
      </div>
    </div>
  </div>

  @if(movements) {
    <app-custom-table [rowsByPage]="10" [headers]="headers" [elements]="movements" [actions]="tableButtons"
      [hasButton]="true" [hasFilter]="true" [hasDownload]="true" [downloadOptions]="downloadOptions"
      (downloadAction)="download($event)"></app-custom-table>
  }
</div>
